function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ========================================================================
 * Apricot's International Phone
 * ======================================================================== */

// SCSS
import "../scss/includes/forms-international-phone.scss";

// javaScript
import Utils from "./CBUtils";
import countriesList from "../api/CBCountries.json";

// ------------------------------------  INTERNATIONAL PHONE INPUT
/**
 * International Phone Input
 *
 * @export
 * @param {Object} data
 * @param {Element} data.elem
 * @param {Array} data.countries
 * @param {String} data.defaultCountry
 * @param {Number} data.defaultValue
 * @param {Number} data.maxLength
 * @param {Array} data.preferredCountries
 * @param {Boolean} data.XPMAll
 * @param {String} data.placeholder
 * @param {Function} data.onNumberChange
 * @param {Function} data.onCountryChange
 * @returns {{updateNumber: Function}}
 * @returns {{updateCountry: Function}}
 * @returns {{updateMaxLength: Function}}
 * @returns {{destroy: Function}}
 *
 */
var IntPhone = function IntPhone() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultData = {
    elem: null,
    countries: null,
    defaultCountry: "us",
    defaultValue: 0,
    maxLength: null,
    preferredCountries: ["us", "ca"],
    XPMAll: false,
    placeholder: "(###) ###-####"
  };
  var elem = data.elem;
  if (!Utils.elemExists(elem)) return false;
  data = _objectSpread(_objectSpread({}, defaultData), data);
  var countries = [];
  var preferredCountries = data.preferredCountries;
  var defaultCountry = data.defaultCountry;
  var defaultValue = data.defaultValue;
  var placeholder = data.placeholder;
  var input = null;
  var ul = null;
  var dropdown = null;
  var toggle = null;
  var flag = null;
  var dialCodeSpan = null;
  var srOnly = null;
  var openIcon = null;
  var closeIcon = null;
  var filterCode = "";
  var filterType = "";
  var countryCode = "";
  var dialCode = 0;
  var disabled = false;
  var maxLength = null;
  var init = function init() {
    elem.intPhonePlugin = "cb";
    ul = elem.querySelector(".cb-country-list");
    if (!Utils.elemExists(ul)) return false;
    dropdown = elem.querySelector(".cb-flag-dropdown");
    toggle = elem.querySelector(".cb-flag-selected");
    input = elem.querySelector("input");
    flag = toggle.querySelector(".cb-flag");
    srOnly = flag.querySelector(".sr-only");
    dialCodeSpan = flag.querySelector(".cb-dial-code");
    if (input.disabled === true) {
      disabled = true;
      Utils.addClass(input, "cb-disabled");
      Utils.attr(toggle, "disabled", "true");
      Utils.attr(toggle, "tabIndex", "-1");
    }

    // if we don't have a list, use default
    // for react component
    if (data.countries) {
      countries = data.countries;
    } else if (data.XPMAll === false) {
      countries = countriesList.countries.filter(function (c) {
        return c.country === true;
      });
    } else {
      countries = countriesList.countries;
    }
    var icons = toggle.querySelectorAll(".cb-icon");
    if (icons[0]) {
      openIcon = icons[0];
      if (icons[1]) {
        closeIcon = icons[1];
      }
    }
    processCountryData();
    buildList();

    // Events
    toggleEvents();
    closeOnClickOutside();
    dropdownEvents();
    inputEvents();
    floatingLabelEvents();
    if (Utils.isBlank(defaultCountry)) {
      defaultCountry = "us";
    }
    updateCountry(defaultCountry);
    if (countryCode !== "us" && countryCode !== "ca") {
      updateMaxLength(data.maxLength);
    }
    if (defaultValue && parseInt(defaultValue) > 0) {
      updateNumber(defaultValue, 0, 0);
    }
  };
  var updateNumber = function updateNumber(num, selectionStart, selectionEnd) {
    var numValue = handlePlaceholderChange(num);
    setValue(numValue, num, selectionStart, selectionEnd);
  };
  var processCountryData = function processCountryData() {
    if (preferredCountries.length > 0) {
      var pcArr = [];
      preferredCountries.reverse();
      preferredCountries.forEach(function (iso) {
        if (countries.find(function (obj) {
          return obj.iso === iso;
        })) {
          var isoIndex = countries.map(function (item) {
            return item.iso;
          }).indexOf(iso);
          pcArr.push(countries[isoIndex]);
          countries.splice(isoIndex, 1);
        }
      });
      pcArr.forEach(function (c) {
        countries.unshift(c);
      });
    }
  };
  var buildList = function buildList() {
    countries.forEach(function (country, index) {
      var li = document.createElement("LI");
      Utils.addClass(li, "cb-country");
      Utils.attr(li, "role", "presentation");
      var a = document.createElement("A");
      Utils.attr(a, "data-cb-dial-code", country.dialCode);
      Utils.attr(a, "data-cb-country-code", country.iso);
      Utils.attr(a, "href", "#");
      Utils.attr(a, "role", "option");

      // const span1 = document.createElement("SPAN");
      // Utils.addClass(span1, "cb-flag");
      // Utils.addClass(span1, country.iso);
      // Utils.attr(span1, "aria-hidden", "true");
      // a.appendChild(span1);

      var span1 = document.createElement("SPAN");
      span1.innerHTML = "".concat(country.countryName, " (+").concat(country.dialCode, ")");
      a.appendChild(span1);
      li.appendChild(a);
      ul.appendChild(li);
    });
  };
  var updateCountry = function updateCountry(code) {
    var country = {};
    setValue("", "", 0, 0);
    Utils.removeAttr(flag, "class");
    Utils.addClass(flag, "cb-flag");
    if (!isNaN(code)) {
      country = getDialCodeData(code);
    } else if (code !== "") {
      country = getCountryData(code);
    }
    if (Utils.isEmptyObject(country)) {
      noFlag();
    } else {
      if (country.iso !== "") {
        countryCode = country.iso;
        dialCode = country.dialCode;
        Utils.addClass(flag, countryCode);
        Utils.attr(toggle, "data-cb-country-code", countryCode);
        Utils.attr(toggle, "data-cb-dial-code", dialCode);
        if (Utils.elemExists(dialCodeSpan)) {
          dialCodeSpan.innerHTML = "+".concat(dialCode);
        }
        srOnly.innerHTML = "Country code for ".concat(country.countryName, " is selected");
        selectListFlag(countryCode);

        // update placeholder
        setPlaceholder(countryCode, placeholder);

        //trigger custom event
        var event = new CustomEvent("apricot_intPhone");
        event.data = country;
        elem.dispatchEvent(event);
        var changeEvent = new Event("change");
        input.dispatchEvent(changeEvent);
        data.onCountryChange && data.onCountryChange(dialCode);
      }
    }
    filterCode = "";
  };
  var updateMaxLength = function updateMaxLength(max) {
    if (typeof max === "number" && max > 0) {
      maxLength = max;
      if (countryCode !== "us" && countryCode !== "ca") {
        Utils.attr(input, "maxlength", max);
      }
    } else {
      maxLength = null;
      if (countryCode !== "us" && countryCode !== "ca") {
        Utils.removeAttr(input, "maxlength");
      }
    }
  };
  var getCountryData = function getCountryData(iso) {
    var obj = countries.filter(function (country) {
      return country.iso === iso;
    })[0];
    if (obj) {
      return obj;
    } else {
      return {};
    }
  };
  var getDialCodeData = function getDialCodeData(dialCode) {
    var obj = countries.filter(function (country) {
      return country.dialCode === dialCode;
    })[0];
    if (obj) {
      return obj;
    } else {
      return {};
    }
  };
  var selectListFlag = function selectListFlag(iso) {
    var item = ul.querySelector("[data-cb-country-code=\"".concat(iso, "\"]"));
    if (Utils.elemExists(item)) {
      Utils.removeClass(ul.querySelector(".cb-selected"), "cb-selected");
      Utils.addClass(item, "cb-selected");
    }
  };
  var openDropdown = function openDropdown(e) {
    e.preventDefault();
    e.stopPropagation();

    // space, down
    if (e.keyCode === 32 || e.keyCode === 40) {
      if (!Utils.hasClass(dropdown, "cb-open")) {
        toggleDropdown(e);
      }
    }
  };
  var adjustDropdownPosition = function adjustDropdownPosition() {
    var top = dropdown.getBoundingClientRect().top;
    var mHeight = dropdown.offsetHeight;
    var wHeight = Utils.windowsDimension().height;
    var limit = parseInt(wHeight - top);
    if (mHeight > limit) {
      Utils.addClass(dropdown, "cb-revers");
    } else {
      Utils.removeClass(dropdown, "cb-revers");
    }
  };
  var toggleDropdown = function toggleDropdown(e) {
    if (e) e.preventDefault();

    // disabled
    if (disabled) return null;

    // is open -> close
    if (Utils.hasClass(dropdown, "cb-open")) {
      Utils.removeClass(dropdown, "cb-open");
      Utils.removeClass(dropdown, "cb-revers");
      Utils.removeClass(openIcon, "cb-hidden");
      Utils.addClass(closeIcon, "cb-hidden");
      Utils.attr(toggle, "aria-expanded", "false");
      Utils.removeAttr(input, "disabled");
      input.focus();
    } else {
      Utils.attr(input, "disabled", "true");
      Utils.addClass(dropdown, "cb-open");
      adjustDropdownPosition();
      Utils.removeClass(closeIcon, "cb-hidden");
      Utils.addClass(openIcon, "cb-hidden");
      Utils.attr(toggle, "aria-expanded", "true");
      if (Utils.elemExists(ul.querySelector(".cb-selected"))) {
        ul.querySelector(".cb-selected").focus();
      } else {
        ul.querySelectorAll(".cb-country a")[0].focus();
      }
    }
  };
  var toggleEvents = function toggleEvents() {
    toggle.addEventListener("click", toggleDropdown);
    toggle.addEventListener("keyup", openDropdown);
    toggle.addEventListener("focus", toggleFocusAnchor(true));
    toggle.addEventListener("blur", toggleFocusAnchor(false));
  };
  var toggleFocusAnchor = function toggleFocusAnchor(mode) {
    if (disabled) return null;
    if (mode) {
      Utils.addClass(dropdown, "cb-focus");
    } else {
      Utils.removeClass(dropdown, "cb-focus");
    }
  };
  var closeOnClickOutside = function closeOnClickOutside() {
    document.addEventListener("keydown", closeA11Y, true);
    document.addEventListener("click", closeA11Y, true);
  };
  var closeA11Y = function closeA11Y(e) {
    if (e.type === "click") {
      if (!Utils.hasClass(dropdown, "cb-open") || dropdown.contains(e.target)) {
        return;
      }
      toggleDropdown();
    } else if (e.keyCode === 27) {
      if (!Utils.hasClass(dropdown, "cb-open")) {
        return;
      }
      toggleDropdown();
    }
  };
  var dropdownEvents = function dropdownEvents() {
    ul.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // flag has change, reset input
        updateCountry(Utils.attr(link, "data-cb-country-code"));
        toggleDropdown();
      });
      link.addEventListener("keydown", function (e) {
        var k = e.which || e.keyCode;
        if (k >= Utils.KEYS.ZERO && k <= Utils.KEYS.NINE) {
          filterCode = filterType === "number" ? filterCode : "";
          filterType = "number";
          filterListFlag(String.fromCharCode(e.which), "dial");
        } else if (k >= Utils.KEYS.A && k <= Utils.KEYS.Z) {
          filterCode = filterType === "string" ? filterCode : "";
          filterType = "string";
          filterListFlag(String.fromCharCode(e.which), "country");
        } else if (/(9|16)/.test(k)) {
          //tab/shift
          var index = 0;
          var tabbingBack = e.shiftKey;
          var items = ul.querySelectorAll("a");
          Array.prototype.forEach.call(items, function (item, i) {
            if (link === item) {
              index = i;
            }
          });
          if (k === 9 && tabbingBack && index === 0) {
            //make sure menus are closed after tab away

            toggleDropdown();
          } else if (!tabbingBack && index === items.length - 1) {
            e.preventDefault();
            var newActive = items.item(0);
            newActive.focus();
          } else {
            //up/down arrows
            if (k === 9 && tabbingBack) {
              index--; //up|shift+tab
            } else if (k === 9) {
              index++; //down|tab
            }

            if (index < 0 || index === items.length) {
              return;
            }
          }
        } else if (/(38|40)/.test(k)) {
          //up/down
          var _index = 0;
          var _items = ul.querySelectorAll("a");
          Array.prototype.forEach.call(_items, function (item, i) {
            if (link === item) {
              _index = i;
            }
          });
          if (k === 38) {
            _index--; //up|shift+tab
          } else if (k === 40) {
            _index++; //down|tab
          }

          if (_index < 0 || _index === _items.length) {
            return;
          }
          var _newActive = _items.item(_index);
          _newActive.focus();
        }
      });
      link.addEventListener("keyup", function (e) {
        if (Utils.isKey(e, "ESC")) {
          //esc
          e.preventDefault();
          toggleDropdown();
        }
      });
    });
  };
  var floatingLabelEvents = function floatingLabelEvents() {
    var wrapper = Utils.getClosest(elem, ".cb-int-phone");
    if (!Utils.elemExists(wrapper)) return false;
    var isFloating = Utils.hasClass(wrapper, "cb-floating-label");
    var label = wrapper.querySelector("label");
    if (isFloating) {
      // floatingLabel custom event
      input.addEventListener("apricot_inputBlur", function () {
        Utils.addClass(label, "cb-focus-fl");
        setTimeout(function () {
          if (toggle === document.activeElement || Utils.hasClass(dropdown, "cb-focus") || Utils.hasClass(dropdown, "cb-open")) {
            // keep it
            Utils.addClass(label, "cb-focus-fl");
          } else {
            // remove it
            Utils.removeClass(label, "cb-focus-fl");
          }
        }, 50);
      });
    }
  };
  var inputEvents = function inputEvents() {
    input.addEventListener("keydown", inputKeyDown);
    input.addEventListener("keyup", inputKeyUp);
  };
  var inputKeyDown = function inputKeyDown(e) {
    // if (Utils.isKey(e, "PREV")) {
    //   //prev
    //   e.preventDefault();

    //   toggle.focus();
    // } else
    if (Utils.isKey(e, "DOWN") || Utils.isKey(e, "UP")) {
      //down/up
      e.preventDefault();
      toggleDropdown();
    }
  };
  var inputKeyUp = function inputKeyUp(e) {
    var k = e.which || e.keyCode;
    var _e$target = e.target,
      value = _e$target.value,
      selectionStart = _e$target.selectionStart,
      selectionEnd = _e$target.selectionEnd;
    var numValue = "";
    if (value !== "") {
      if (k >= Utils.KEYS.SPACE && !e.metaKey || k === Utils.KEYS.DEL) {
        // 32 is space, and after that it's all chars (not meta/nav keys)
        // del may change the number too
        numValue = handlePlaceholderChange(value);
        setValue(numValue, value, selectionStart, selectionEnd);
      }
    }
  };
  var setPlaceholder = function setPlaceholder(code, value) {
    if (code === "us" || code === "ca") {
      var mask = "".concat(value);
      Utils.attr(input, "placeholder", mask);
      Utils.attr(input, "maxlength", mask.length);
    } else {
      Utils.removeAttr(input, "placeholder");
      if (typeof maxLength === "number") {
        Utils.attr(input, "maxlength", maxLength);
      } else {
        Utils.removeAttr(input, "maxlength");
      }
    }
  };
  var handlePlaceholderChange = function handlePlaceholderChange(value) {
    var newValue = "";
    var strippedValue = "";
    var isInt = false;
    var matchesNumber = false;
    value = value.toString();
    var num = "#";
    value = value.replace("+".concat(dialCode), "");

    // strip all characters
    strippedValue = value.replace(/\D/g, "");
    if (dialCode === "1") {
      for (var i = 0, j = 0; i <= placeholder.length; i++) {
        isInt = !isNaN(parseInt(strippedValue[j]));
        matchesNumber = num.indexOf(placeholder[i]) >= 0;
        if (matchesNumber && isInt) {
          newValue += strippedValue[j++];
        } else if (!isInt && matchesNumber) {
          return newValue;
        } else {
          newValue += placeholder[i];
        }
        if (strippedValue[j] === undefined) {
          break;
        }
      }
    } else {
      newValue = strippedValue;
    }
    return newValue;
  };
  var filterListFlag = function filterListFlag(code, type) {
    var newCode = "";
    var theFlag = null;
    code = code.toLowerCase();
    if (filterCode !== "") {
      if (type === "country") {
        newCode = filterCode.length >= 2 ? code : filterCode + code;
      } else {
        newCode = ul.querySelectorAll("[data-cb-".concat(type, "-code^=\"").concat(filterCode + code, "\"]")) ? filterCode + code : code;
      }
      theFlag = ul.querySelectorAll("[data-cb-".concat(type, "-code^=\"").concat(newCode, "\"]"))[0];
      if (theFlag) {
        theFlag.focus();
        filterCode = newCode;
      } else {
        filterCode = "";
      }
    } else {
      theFlag = ul.querySelectorAll("[data-cb-".concat(type, "-code^=\"").concat(code, "\"]"))[0];
      if (theFlag) {
        theFlag.focus();
        filterCode = code;
      }
    }
  };
  var noFlag = function noFlag() {
    var value = input.value;

    //No country
    if (value === "" || value === "+") {
      if (Utils.attr(toggle, "data-cb-country-code") !== "") {
        Utils.removeClass(flag, Utils.attr(toggle, "data-cb-country-code"));
        Utils.removeAttr(toggle, "data-cb-country-code");
        Utils.removeAttr(toggle, "data-cb-dial-code");
        srOnly.innerHTML = "Select country code";
      }
    }
  };
  var setValue = function setValue(newValue, value, selectionStart, selectionEnd) {
    if (dialCode > 0 && newValue !== "") {
      dialCodeSpan.innerHTML = "+".concat(dialCode);
    }
    data.onNumberChange && data.onNumberChange(newValue);

    // calculate cursor position
    var diff = newValue.length - value.length;
    var adjustedCursorStart = selectionStart + diff;
    var adjustedCursorEnd = selectionEnd + diff;
    input.value = newValue;
    var newStart = Math.min(adjustedCursorStart, newValue.length);
    var newEnd = Math.min(adjustedCursorEnd, newValue.length);
    input.setSelectionRange(newStart, newEnd);

    // input.value = value;
  };

  var destroy = function destroy() {
    if (elem.intPhonePlugin === "cb") {
      elem.intPhonePlugin = null;
      toggle.removeEventListener("click", toggleDropdown);
      toggle.removeEventListener("keyup", openDropdown);
      toggle.removeEventListener("focus", toggleFocusAnchor(true));
      toggle.removeEventListener("blur", toggleFocusAnchor(false));
      input.removeEventListener("keydown", inputKeyDown);
      input.removeEventListener("keyup", inputKeyUp);
      document.removeEventListener("keydown", closeA11Y, true);
      document.removeEventListener("click", closeA11Y, true);
      ul.innerHTML = "";
    }
  };
  if (elem.intPhonePlugin !== "cb") {
    init();
  }
  return {
    destroy: destroy,
    updateNumber: updateNumber,
    updateCountry: updateCountry,
    updateMaxLength: updateMaxLength
  };
};
export default IntPhone;